/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ChatIcon = /*#__PURE__*/ createSvgIcon(
  'ChatIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.5 15c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 016 13.5v-1h9.5V6h1c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v8.688c0 .335-.153.569-.458.7-.306.13-.578.076-.815-.161L15 15H7.5zm-2.502-4l-1.725 1.727c-.238.237-.51.29-.815.16-.305-.132-.458-.366-.458-.704V3.5c0-.417.146-.77.438-1.063A1.447 1.447 0 013.5 2h9c.417 0 .77.146 1.063.438.291.291.437.645.437 1.062v6c0 .417-.146.77-.438 1.063A1.446 1.446 0 0112.5 11H4.998zM12.5 9.5v-6h-9v6h9z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ChatIcon;
